import React, { useState } from "react";
import { uploadAgency, uploadFile } from "../../DAL/create";
import {
  Box,
  Button,
  CircularProgress,
  Typography,
  TextField,
  MenuItem,
  FormHelperText,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { enqueueSnackbar } from "notistack";

function AddAgency() {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [fileName, setFileName] = useState("");
  const [fileUploaded, setFileUploaded] = useState(false);
  const [fileURL, setFileURL] = useState("");
  const navigate = useNavigate();

  const [name, setName] = useState("");
  const [country, setCountry] = useState("");
  const [email, setEmail] = useState("");
  const [type, setType] = useState(false);
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [userName, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [bankName, setBankName] = useState("");
  const [bankAccountName, setBankAccountName] = useState("");

  const handleFileChange = (e) => {
    const selectedFile = e.target.files[0];
    setFile(URL.createObjectURL(selectedFile));
    // setFile(selectedFile);
    setFileName(selectedFile ? selectedFile.name : "");
    setFileUploaded(false);
  };

  const handleFileSubmit = async (e) => {
    e.preventDefault();
    if (!file) {
      setType(true);
      return;
    }

    const formData = new FormData();
    formData.append("image", file);

    setLoading(true);
    try {
      const imagedata = await uploadFile(formData);
      setFileURL(imagedata.data.url);
      setFileUploaded(true);
      enqueueSnackbar("File uploaded successfully!", { variant: "success" });
    } catch (error) {
      console.error("Error uploading file:", error);
      enqueueSnackbar("Failed to upload file. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!name) {
    //   setType(true);
    //   return;
    // }
    // if (!email) {
    //   setType(true);
    //   return;
    // }
    // if (!fileURL) {
    //   setType(true);
    //   return;
    // }

    const Payload = {
      picture: fileURL,
      name,
      country,
      email,
      phone,
      address,
      userName,
      password,
      bankName,
      bankAccountName,
    };

    setLoading(true);
    try {
      const resp = await uploadAgency(Payload);
      if (resp?.status === 200 || resp?.status === 201) {
        enqueueSnackbar("Agency created successfully!", { variant: "success" });
        navigate("/agencylist");
      } else {
        enqueueSnackbar(
          resp?.message[0]?.constraints || resp?.message || resp?.data?.message,
          {
            variant: "error",
          }
        );
      }
    } catch (error) {
      console.error("Error creating agency:", error);
      enqueueSnackbar("Failed to create agency. Please try again.", {
        variant: "error",
      });
    } finally {
      setLoading(false);
    }
  };

  const labelStyles = {
    color: "", // Default label color
    "&.Mui-focused": {
      color: "#8F29D0", // Focused label color (green)
    },
  };
  const inputStyles = {
    marginBottom: 2,
    "& .MuiOutlinedInput-root": {
      "&:hover fieldset": {
        borderColor: "#8F29D0", // Hover border color
      },
      "&.Mui-focused fieldset": {
        borderColor: "#8F29D0", // Focus border color (green)
      },
    },
  };

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        alignItems: "center",
        maxWidth: 400,
        margin: "auto",
        mt: 4,
        mb: 2,
      }}
    >
      <Typography id="modal-title" variant="h6" component="h2">
        Create Agency
      </Typography>

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Agency Name"
        variant="outlined"
        name="name"
        value={name}
        onChange={(e) => setName(e.target.value)}
      />

      <FormHelperText sx={{ color: "red" }}>
        {type == true && !name && "Name field is required"}
      </FormHelperText>
      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Country"
        variant="outlined"
        name="country"
        value={country}
        onChange={(e) => setCountry(e.target.value)}
      />

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Email"
        variant="outlined"
        name="email"
        value={email}
        onChange={(e) => setEmail(e.target.value)}
      />
      <FormHelperText sx={{ color: "red" }}>
        {type == true && !email && "Email field is required"}
      </FormHelperText>

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Phone"
        variant="outlined"
        name="phone"
        value={phone}
        onChange={(e) => setPhone(e.target.value)}
      />

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Address"
        variant="outlined"
        name="address"
        value={address}
        onChange={(e) => setAddress(e.target.value)}
      />

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Username"
        variant="outlined"
        name="userName"
        value={userName}
        onChange={(e) => setUserName(e.target.value)}
      />

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Password"
        variant="outlined"
        name="password"
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
      />

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Bank Name"
        variant="outlined"
        name="bankName"
        value={bankName}
        onChange={(e) => setBankName(e.target.value)}
      />

      <TextField
        sx={inputStyles}
        InputLabelProps={{ sx: labelStyles }}
        fullWidth
        required
        label="Bank Account Name"
        variant="outlined"
        name="bankAccountName"
        value={bankAccountName}
        onChange={(e) => setBankAccountName(e.target.value)}
      />

      <Typography variant="h6">Upload Picture</Typography>
      <Box sx={{ width: "100%", display: "flex", gap: 2 }}>
        <input type="file" accept="image/*" onChange={handleFileChange} />
        <Button
          variant="contained"
          color={fileUploaded ? "success" : "primary"}
          onClick={handleFileSubmit}
          disabled={loading || !file}
        >
          {loading ? (
            <CircularProgress size={24} color="inherit" />
          ) : fileUploaded ? (
            "Uploaded"
          ) : (
            "Upload"
          )}
        </Button>
      </Box>
      {file && (
        <>
          <img
            src={file}
            style={{ height: "100px", width: "100px", objectFit: "contain" }}
          />
        </>
      )}

      {/* {fileName && <Typography variant="body2">{fileName}</Typography>} */}
      <FormHelperText sx={{ color: "red" }}>
        {type == true && !fileName && "Image field is required"}
      </FormHelperText>

      <Button
        variant="contained"
        className="gradientButton"
        onClick={handleSubmit}
        fullWidth
        sx={{ textTransform: "none" }}
      >
        Submit Agency
      </Button>
    </Box>
  );
}

export default AddAgency;
